import React, { Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import BillboardRow from './billboard-row';
import BillboardFixed from './BillboardFixed';
import Footer from './footer';
import NavigationBar from './navigation-bar';
import HighlightRow from './highlight-row';
import SVODSideMenu from './SVODSideMenu';
import { removeDropdown } from '../../redux/actions/SVOD';
import { EnvType } from "./constants";
import { cloneDeep } from 'lodash';

const LOLOMO = lazy(() => import('./lolomo'));

class HomePage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			scrollPosition: 0,
			indicatorIdx: 0,
		};

		this.peacockBillboard;
		this.peacockLolomosRow;
	}

	componentDidMount() {
		this.props.removeDropdown();
		this.props.eventHandler({ data: { event_type: "page_enter", page_location: "home_page", time: Date.now() } });
	}

	componentWillUnmount() {
		this.props.eventHandler({ data: { event_type: "page_exit", page_location: "home_page", time: Date.now() } });

		this.props.removeDropdown();
	}

	componentDidUpdate(prevProps) {
		const { svod_env } = this.props.fetchedGroup;
		const targetAsset = this.props.targetAssets ? this.props.targetAssets[this.props.targetAssetIndex] : undefined;
		const targetAssetId = targetAsset ? targetAsset.id || targetAsset._id : "";

		if (this.props.promptCuratedRow
			&& this.props.environment === EnvType.PEACOCK
			&& svod_env.curated_row
		) {
			let scrollLocation = document.getElementById("curated-row");
			if (scrollLocation) {
				scrollLocation.scrollIntoView({
					behavior: "smooth",
					block: "center"
				});
			}

			let rowTitle = '';
			if (this.props.rowInformation) {
				this.props.rowInformation.forEach((row) => {
					if (row.curator_row) {
						rowTitle = row.label;
					}
				});
			}

			this.props.eventHandler({ data: { event_type: 'prompt_curated_content', type: rowTitle } });
		}

		if (this.props.environment === EnvType.PEACOCK
			&& this.props.promptTargetAsset
			&& svod_env.guided_experience
			&& svod_env.guided_experience.target_asset_guide
		) {
			this.props.eventHandler({ data: { event_type: 'peacock_prompt_to_target_asset', page_location: "home_page" } });
		}

		if (this.props.environment !== EnvType.APPLETV) {
			const vidItems = document.getElementsByClassName(`videoItem-billboard`);
			const vidArray = Array.prototype.slice.call(vidItems);

			document.documentElement.style.setProperty('--lolomo-scroll', `${this.state.scrollPosition}px`);
			vidArray.forEach((vidItem) => {
				vidItem.style.transform = `translateX(${this.state.scrollPosition}px`;
			});
		}

		function allFalse(obj) {
			for (var o in obj) {
				if (obj[o]) return false;
			}
			return true;
		}

		if (!allFalse(this.props.inView) && this.state.active) {
			this.setState({ active: false });
		}

		if (this.props.environment === EnvType.PEACOCK
			&& this.props.isFirstSVODLoad
			&& !this.props.surveyLayerActive
		) {
			this.props.eventHandler({ data: { event_type: 'display_welcome_modal' } });
		}

		if (this.props.promptTargetAsset
			&& this.props.environment === EnvType.PEACOCK
			&& !this.props.promptedTargetAsset
		) {
			let targetAssetName = targetAsset ? targetAsset.name : "";
			this.props.eventHandler({
				data: {
					event_type: 'peacock_prompt_to_target_asset',
					page_location: "home_page",
					targetAsset: targetAssetName
				}
			});
		}

		if (this.props.promptForcedTargetAsset
			&& this.props.environment === EnvType.PEACOCK
			// && !this.props.promptedForceTargetAsset // Commented out to allow forced entry again if the user leaves the target asset after the first force
		) {
			let targetAssetName = targetAsset ? targetAsset.name : "";
			this.props.eventHandler({
				data: {
					event_type: 'peacock_force_to_target_asset',
					page_location: "home_page",
					targetAsset: targetAssetName
				}
			});
		}

		if (this.props.beginAppleGuidedExperience
			&& this.props.environment === EnvType.APPLETV
			&& !this.props.promptedTargetAsset
		) {
			let targetAssetName = targetAsset ? targetAsset.name : "";
			this.props.eventHandler({ data: { event_type: 'apple_prompt_to_target_asset', page_location: "home_page", targetAsset: targetAssetName } });
		}

		if (this.props.forceGuidedExperience
			&& this.props.environment === EnvType.APPLETV
			&& !this.props.promptedForceTargetAsset
		) {
			let targetAssetName = targetAsset ? targetAsset.name : "";
			this.props.eventHandler({ data: { event_type: 'apple_force_to_target_asset', page_location: "home_page", targetAsset: targetAssetName } });
		}

		if (this.props.autoNavigateToTargetAsset) {
			const targetAssetNode = document.getElementById(targetAssetId);
			if (targetAssetNode) targetAssetNode.click();
		}

		if (this.props.autoNavigateToIncludedAppleTVPage) { // this needs to be set to false once entnering the appletv page - EG
			const targetAssetId = 'includedAppleTVPage';
			const targetAssetNode = document.getElementById(targetAssetId);
			if (targetAssetNode) targetAssetNode.click();
		}

		let peacockBillboard = document.getElementById("PeacockFixedBillboard");
		if (peacockBillboard
			&& !this.peacockBillboard
			&& !this.peacockLolomosRow
			&& this.props.environment === EnvType.PEACOCK
		) {
			this.peacockBillboard = peacockBillboard;
			this.peacockLolomosRow = document.getElementById("HomePageLolomos");

			this.peacockBillboard.onmousewheel = (event) => {
				this.peacockLolomosRow.scrollTop += event.deltaY;
			};
		}
	}

	render() {
		const {
			environment,
			videos,
			dropdown,
			rowInformation
		} = this.props;

		const cloneVideos = cloneDeep(videos);
		const allVideoRows = Object.keys(cloneVideos);
		allVideoRows.forEach((row) => {
			const keys = Object.keys(cloneVideos[row]);
			keys.forEach((key) => {
				const video = cloneVideos[row][key];
				if (video.transactional) delete cloneVideos[row][key];
			});
		});

		let nonBillboardRows = allVideoRows.filter((value) => value.indexOf("Billboard") < 0);
		let isDynamicBillboard = false;
		let lolomos = nonBillboardRows.map((row, idx) => {
			let isCuratedRow = false; // Peacock curated content study
			let contentType = ""; // highlight, latest_releases, coming_soon
			let description;
			let currentRowInfoObject;

			if (rowInformation) {
				rowInformation.forEach((rowInfoObject) => {
					if (row.includes(rowInfoObject.id)) {
						if (rowInfoObject.curator_row) {
							isCuratedRow = true;
						}
						if (rowInfoObject.row_type) {
							contentType = rowInfoObject.row_type;
						}
						if (rowInfoObject.display_type === "highlight") {
							contentType = "highlight";
						}
						description = rowInfoObject.description;
						currentRowInfoObject = rowInfoObject;
					}
				});
			}

			if (contentType === "highlight") {
				return (
					<HighlightRow {...this.props}
						pageLocation='home_page'
						videos={cloneVideos[row]}
						activeDropdown={dropdown}
						isCuratedRow={isCuratedRow}
						label={row}
						key={`highlight`}
					/>
				);
			}
			else {
				return (
					<Suspense fallback={<div></div>}>
						<LOLOMO {...this.props}
							pageLocation='home_page'
							videos={cloneVideos[row]}
							rowIndex={idx}
							row_type={contentType}
							activeDropdown={dropdown}
							isCuratedRow={isCuratedRow}
							rowInfoObject={currentRowInfoObject}
							label={row}
							key={`lolomo`}
							description={description}
						/>
					</Suspense>
				);
			}
		});

		if (rowInformation) {
			isDynamicBillboard = !!rowInformation.find(rowObj => rowObj.dynamic_billboard);
		}

		const style = isDynamicBillboard ? { top: '-236px', marginBottom: '-236px' } : {};
		const addedClass = isDynamicBillboard ? 'position-absolute' : '';

		return (
			<div className="index position-relative" id="svod-page" >
				{environment === EnvType.PEACOCK
					? <SVODSideMenu {...this.props} page="home_page" />
					: <NavigationBar {...this.props} addedClass={addedClass} page="home_page" />
				}

				<div className="content-wrapper">
					<BillboardRow {...this.props} videos={cloneVideos} isDynamicBillboard={isDynamicBillboard} />

					<div id="HomePageLolomos" className={`${environment === EnvType.PEACOCK ? "peacock-rows-wrapper" : "video-index position-relative"}`} style={style}>
						{lolomos}
					</div>

					<Footer environment={environment} />
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	videos: state.SVOD.videos,
	dropdown: state.SVOD.dropdown,
	environment: state.SVOD.environment,
	rowInformation: state.targetProcess.fetchedGroup.svod_env.rows,
	targetAssets: state.targetProcess.fetchedGroup.svod_env.target_assets,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	removeDropdown: () => dispatch(removeDropdown()),
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/components/svod/home-page.jsx